import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Sidebar from './sidebar';
import Overlay from '../components/overlay';
import Header from './header';
import { get_detailed_order_report } from '../actions/index';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import moment from 'moment';
import DetailedOrderReport from './detailed_order_report';

class DetailedOrder extends Component {
  constructor(props) {
    super(props);

    this.state = {
      from_selectedDay: undefined,
      to_selectedDay: undefined,
      report_day_from: '',
      report_day_to: '',
      report_created: ''
    }
  }

  from_handleDayChange = (from_selectedDay, modifiers) => {
    this.setState({
      from_selectedDay,
      from_isDisabled: modifiers.disabled,
      to_selectedDay: from_selectedDay,
      to_isDisabled: modifiers.disabled,
    });
  }

  to_handleDayChange = (to_selectedDay, modifiers) => {
    this.setState({
      to_selectedDay,
      to_isDisabled: modifiers.disabled,
    });
  }

  handleReport = () => {
    this.setState({
      report_day_from: moment(this.state.from_selectedDay).format('DD/MM/YYYY'),
      report_day_to: moment(this.state.to_selectedDay).format('DD/MM/YYYY'),
      report_created: Date()
    });
    var report_date_from = moment(this.state.from_selectedDay).format('YYYY-MM-DD');
    var report_date_to = moment(this.state.to_selectedDay).format('YYYY-MM-DD');

    // send report dates to action
    this.props.get_detailed_order_report(report_date_from, report_date_to);
  }

  render() {
    const DAY_FORMAT = 'DD/MM/YYYY';
    const { from_selectedDay, to_selectedDay } = this.state;
    const from_formattedDay = from_selectedDay
      ? moment(from_selectedDay).format(DAY_FORMAT)
      : '';
    const to_formattedDay = to_selectedDay
      ? moment(to_selectedDay).format(DAY_FORMAT)
      : '';

    const dayPickerProps = {
      todayButton: 'Go to Today',
      disabledDays: {
        daysOfWeek: [0, 6],
      },
      enableOutsideDays: true,
      modifiers: {
        monday: { daysOfWeek: [1] },
      },
    };

    // If the server has yet to send back report items, then show the loading page
    if (this.props.reports.loading) {
      return (
        <div>
          <Overlay />
          <Sidebar />
          <Header />
          <div className="site-content">
            <nav className="navbar navbar-light bg-white navbar-bottom-line b-a mb-1 p-1">
              <div className="col-md-10 mb-2 mb-md-0">
                <h5>Choose a day and click Load Report.</h5>
                <b>From:</b>&nbsp;
              <DayPickerInput
                value={from_formattedDay}
                onDayChange={this.from_handleDayChange}
                format={DAY_FORMAT}
                placeholder={`E.g. ${moment().locale('en').format(DAY_FORMAT)}`}
                dayPickerProps={dayPickerProps}
              />
              &nbsp;&nbsp;
              <b>To:</b>&nbsp;
              <DayPickerInput
                value={to_formattedDay}
                onDayChange={this.to_handleDayChange}
                format={DAY_FORMAT}
                placeholder={`E.g. ${moment().locale('en').format(DAY_FORMAT)}`}
                dayPickerProps={dayPickerProps}
              />
                &nbsp;
                <input type="button" className="btn btn-primary b-a" onClick={event => this.handleReport()} value="Load Report" />
              </div>
            </nav>
            <div className="content-area py-1">
              <div className="container-fluid">
                Loading...
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div>
        <Overlay />
        <Sidebar />
        <Header />
        <div className="site-content">
          <nav className="navbar navbar-light bg-white navbar-bottom-line b-a mb-1 p-1">
            <div className="col-md-10 mb-2 mb-md-0">
              <h5>Choose a day and click Load Report.</h5>
              <b>From:</b>&nbsp;
              <DayPickerInput
                value={from_formattedDay}
                onDayChange={this.from_handleDayChange}
                format={DAY_FORMAT}
                placeholder={`E.g. ${moment().locale('en').format(DAY_FORMAT)}`}
                dayPickerProps={dayPickerProps}
              />
              &nbsp;&nbsp;
              <b>To:</b>&nbsp;
              <DayPickerInput
                value={to_formattedDay}
                onDayChange={this.to_handleDayChange}
                format={DAY_FORMAT}
                placeholder={`E.g. ${moment().locale('en').format(DAY_FORMAT)}`}
                dayPickerProps={dayPickerProps}
              />
              &nbsp;
              <input type="button" className="btn btn-primary b-a" onClick={event => this.handleReport()} value="Load Report" />
            </div>
          </nav>
          <div className="content-area py-1">
            <div className="container-fluid">
              <DetailedOrderReport report_created={this.state.report_created} report_day_from={this.state.report_day_from} report_day_to={this.state.report_day_to} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps({ reports }) {
  return { reports };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators( { get_detailed_order_report }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(DetailedOrder);



// WEBPACK FOOTER //
// ./src/containers/detailed_order.js